import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
export function PurchaseTerms() {
  return <section aria-labelledby="purchase-terms" className="bg-white px-4 py-16 sm:py-24" data-id="element-288" data-mp="2ym0gfeuf5fmi">
      <div className="mx-auto max-w-3xl" data-id="element-289" data-mp="33js765jbuvp4">
        <div className="rounded-3xl bg-navy-900 p-7 text-white sm:p-10" data-id="element-290" data-mp="38ba4mjm56e5c">
          <div className="flex flex-col items-center text-center" data-id="element-291" data-mp="38clcauipk61q">
            <span className="flex h-20 w-20 items-center justify-center rounded-full bg-cta text-navy-950" data-id="element-292" data-mp="3d9bqtdev6tl1">
              <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-293" data-mp="3hanf9fm058rn" />
            </span>
            <h2 id="purchase-terms" className="mt-5 font-display text-3xl font-black sm:text-4xl" data-id="element-294" data-mp="3mccul7g9c8lj">
              Your purchase terms
            </h2>
            <p className="mt-3 text-lg font-semibold text-aqua" data-id="element-295" data-mp="1rx0hfstmyvg3">
              Review the ABG Clinical Roadmap™ and decide whether it fits your learning needs.
            </p>
          </div>
          <div className="mt-7 space-y-4 text-[17px] leading-relaxed text-white/80" data-id="element-296" data-mp="1wxy9qy8d15vb">
            <p data-id="element-297" data-mp="3fad7u4ka7ldd">I want you to understand exactly what you’re purchasing.</p>
            <p data-id="element-298" data-mp="3ags8o96yclcl">
              Your collection includes six educational volumes, five complementary bonuses, and practical resources for studying
              arterial blood gas concepts.
            </p>
            <p data-id="element-299" data-mp="31igjmblqhvm9">Before completing your purchase, review the delivery details and refund policy presented at checkout.</p>
            <p data-id="element-300" data-mp="1znxql52feh3">
              If a seven-day satisfaction guarantee applies to your purchase, the published refund terms will explain how to
              request a refund and which conditions apply.
            </p>
            <p className="font-semibold text-white" data-id="element-301" data-mp="3p8as6gz0sy0p">
              My goal is to give you a clear understanding of the material so you can make an informed purchasing decision.
            </p>
          </div>
        </div>

        <SectionCta label="Get the ABG Clinical Roadmap™" data-id="element-302" data-mp="28rorpqbpbt4q" />
      </div>
    </section>;
}